import ctl from '@netlify/classnames-template-literals'
import { MouseEvent, ReactNode } from 'react'
import { ScaleProps } from '../../utilities'

export type ButtonProps = {
	children?: ReactNode
	onClick?: (e: MouseEvent<HTMLButtonElement>) => void
	icon?: ReactNode
	iconOnly?: boolean
	type?: 'primary' | 'secondary' | 'tertiary' | 'danger' | 'hover'
	size?: 'tall' | 'medium' | 'short'
	inline?: boolean // todo
	borderless?: boolean // todo
	danger?: boolean // todo
	disabled?: boolean
	htmlButtonType?: 'submit' | 'reset' | 'button'
} & ScaleProps

export function Button(
	{
		onClick,
		children,
		icon,
		iconOnly = false,
		inline,
		type = 'secondary',
		size = 'medium',
		scale = 'medium',
		disabled = false,
		htmlButtonType = 'submit',
	}: ButtonProps,
) {
	const primaryWrapperClassName = 'bg-brand-600 text-white'
	const secondaryWrapperClassName = 'bg-purple-100 text-purple-700'
	const tertiaryWrapperClassName = 'bg-white ring-inset ring-[1px] ring-purple-300 text-purple-600'
	const hoverWrapperClassName = 'bg-grey-50 text-grey-600 shadow-sm'

	const disabledClassName = 'opacity-50'

	const wrapperClassName = ctl(`
        rounded-md flex gap-[2px] items-center justify-items-center transition-all duration-75
        relative active:top-[1px] active:shadow-none 
        ${type === 'primary' && primaryWrapperClassName}
        ${type === 'secondary' && secondaryWrapperClassName}
        ${type === 'tertiary' && tertiaryWrapperClassName}
        ${type === 'hover' && hoverWrapperClassName}
        ${inline && 'inline-flex mx-2'}
		${disabled && disabledClassName} 
    `)

	const tallInnerClassName = ctl('pt-3.5 pb-3')
	const mediumInnerClassName = ctl('pt-2 pb-1.5')
	const shortInnerClassName = ctl('pt-1 pb-[3px]')

	const xSmallScaleInnerClassName = ctl('text-xs px-2')
	const smallScaleInnerClassName = ctl('text-sm px-3')
	const mediumScaleInnerClassName = ctl('text-base px-4')
	const largeScaleInnerClassName = ctl('text-lg px-4')

	const innerClassName = ctl(`
		${size === 'tall' && tallInnerClassName}
		${size === 'medium' && mediumInnerClassName}
		${size === 'short' && shortInnerClassName}

		${scale === 'x-small' && xSmallScaleInnerClassName}
		${scale === 'small' && smallScaleInnerClassName}
		${scale === 'medium' && mediumScaleInnerClassName}
		${scale === 'large' && largeScaleInnerClassName}
     `)

	return (
		<button onClick={onClick} className={wrapperClassName} disabled={disabled} type={htmlButtonType}>
			{icon
				? (
					/*@TODO: Icon scaling*/
					<div className={`relative ${iconOnly ? 'pr-8 pl-2' : 'left-[12px]'} top-[1px] h-6 w-6`}>
						{icon}
					</div>
				)
				: null}
			{!iconOnly ? <span className={innerClassName}>{children}</span> : null}
		</button>
	)
}
